export const FC_INVALID_PATH = 'InvalidPath';
export const FC_FILE_NOT_FOUND = 'FileNotFound';
export const FC_ITEM_NOT_FOUND = 'ItemNotFound';
export const FC_DUPLICATE_ITEM = 'DuplicateItem';
export const FC_DUPLICATE_FILE = 'DuplicateFile';
export const FC_CONTAINS_EXISTING_FOLDER = 'ContainsExistingFolder';
export const FC_INVALID_CREDENTIALS = 'InvalidCredentials';
export const FC_INSUFFICIENT_PRIVILEGES = 'InsufficientPrivileges';
export const FC_MALFORMED_QUERY_STRING = 'MalformedQueryString';
export const FC_NOT_ALLOWED = 'NotAllowed';
export const FC_INVALID_CHARACTER_ENCODING = 'InvalidCharacterEncoding';
export const FC_INVALID_PARAMETERS = 'InvalidParameters';
export const FC_UNSUPPORTED_TYPE = 'UnsupportedType';
export const FC_UNEXPECTED_ERROR = 'UnexpectedError';
export const FC_SERVER_UNREACHABLE = 'ServerUnreachable'; // Not a server faultcode
export const FC_LICENSE_COUNT_EXCEEDED = 'LicenseCountExceeded';



// WEBPACK FOOTER //
// ./src/portfolio-shared/util/faultCode.js